/**
 * API Configuration
 * Centralized API base URL configuration for all API calls
 */

// Get the backend URL from environment variable or fallback to localhost for development
export const API_BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:5000';

// Helper function to construct API URLs
export const getApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

// Export commonly used API endpoints
export const API_ENDPOINTS = {
  // Deployments
  deployments: '/api/deployments',
  deploymentsById: (id: string) => `/api/deployments/${id}`,
  deploymentsDashboard: (role: string) => `/api/deployments/dashboard/${role}`,
  deploymentsAll: '/api/deployments/all',
  deploymentsUser: (userId: string) => `/api/deployments/user/${userId}`,
  
  // Modules
  modules: '/api/modules',
  modulesById: (id: string) => `/api/modules/${id}`,
  
  // Institutes
  institutes: '/api/institutes',
  institutesById: (id: string) => `/api/institutes/${id}`,
  
  // Users
  users: '/api/users',
  usersById: (userId: string) => `/api/users/${userId}`,
  createUser: '/api/create-user',
  roles: '/api/roles',
  
  // Reports
  reportsDeployments: '/api/reports/deployments',
  reportsSummary: '/api/reports/summary',
  
  // Settings
  settings: '/api/settings',
};

export default API_BASE_URL;
